import React from "react";
import Contact from "../Components/Contact";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

const ContactPage = () => {
  return (
    <div>
      <Header />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;
